/**
 * @typedef {import('../../types').ColumnProps} Props
 */

/**
 * @param {keyof import('../../types').ScannedProduct} [requiredProperty]
 * @returns {(prevProps: Props, nextProps: Props) => boolean}
 */
export const areProductPropsEqual = (requiredProperty) => {
  return (prevProps, nextProps) => {
    const prevData = prevProps.value;
    const nextData = nextProps.value;

    const standardValidation =
      prevData.product.rowKey === nextData.product.rowKey &&
      prevData.product.productId === nextData.product.productId &&
      prevData.product.name === nextData.product.name &&
      prevData.product.sku === nextData.product.sku &&
      prevData.product.thumbnailUrl === nextData.product.thumbnailUrl;

    if (!requiredProperty) {
      return standardValidation;
    }

    return standardValidation && prevData.product[requiredProperty] === nextData.product[requiredProperty];
  };
};
